<template>
  <div class="card border-0">
    <h5 class="card-header bg-primary text-white">Visible Risk Index</h5>
    <div class="card-body p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Category</th>
            <th style="width: 40px;"></th>
            <th class="w-50 d-none d-sm-none d-md-table-cell">Score</th>
            <th class="w-25 d-md-none d-lg-none">Score</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in sortedCategories" :key="category.code" :class="{ 'text-muted': isCategoryDisabled(category) }">
            <td>
              <div class="mt-3">
                <span> {{ category.displayName }}</span>
              </div>
            </td>
            <td class="position-relative">
              <div class="d-flex justify-content-center border-0">
                <div :class="getCategoryBgClass(category)" class="position-absolute" style="top: 0px; left: 0px; width: 16px; height: 16px; line-height: 12px;">
                  <fa :icon="getIcon(category.currentScore)" fixed-width size="xs" />
                </div>
                <CategoryIcon class="px-3 py-1" :categoryCode="category.code" />
              </div>
            </td>
            <td class="d-none d-sm-none d-md-table-cell pt-0">
              <div class="progress">
                <div
                  class="progress-bar"
                  :class="getCategoryBgClass(category)"
                  role="progressbar"
                  :style="{ width: category.currentScore + '%' }"
                  :aria-valuenow="category.currentScore"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </td>
            <td class="d-md-none d-lg-none" :class="getCategoryBgClass(category)">
              <div class="mt-3">
                <h3>{{ category.currentScore }}</h3>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <RiskIndexChart
      v-if="!hasInvestigationId"
      :isLoading="isLoading"
      :organizationId="organizationId"
      :reportId="reportId"
      :report="report"
      class="border-left border-right border-bottom"
    />
  </div>
</template>

<script>
import CategoryIcon from "@/views/reports/report/edit-report/CategoryIcon.vue";
import RiskIndexChart from "@/views/reports/report/edit-report/RiskIndexChart.vue";

export default {
  components: {
    CategoryIcon,
    RiskIndexChart,
  },
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  computed: {
    riskIndex() {
      return this.report ? this.report.riskIndex || {} : {};
    },
    sortedCategories() {
      var categories = this.report ? (this.report.riskIndex ? this.report.riskIndex.categories : []) : [];
      var sortedCategories = categories.slice();

      sortedCategories.sort((x, y) => {
        if (x.displayName < y.displayName) return -1;
        if (x.displayName > y.displayName) return 1;
        return 0;
      });

      return sortedCategories;
    },
    hasInvestigationId() {
      return this.report && this.report.registration && this.report.registration.investigationId;
    },
  },
  methods: {
    getIcon(value) {
      if (!value) return "circle";
      if (value >= 70) return "check";
      if (value >= 50) return "question";
      return "times";
    },
    getCategoryBgClass(category) {
      if (!category) return ["bg-secondary", "text-white"];
      if (this.isCategoryDisabled(category)) return ["bg-secondary", "text-white"];
      if (category.currentScore >= 70) return ["bg-success", "text-white"];
      if (category.currentScore >= 50) return ["bg-warning", "text-white"];
      return ["bg-danger", "text-white"];
    },
    getAverageBgClass(value) {
      if (!value) return ["bg-secondary", "text-white"];
      if (value >= 70) return ["bg-success", "text-white"];
      if (value >= 50) return ["bg-warning", "text-white"];
      return ["bg-danger", "text-white"];
    },
    isCategoryDisabled(category) {
      return category.statusCode != "enabled";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

table {
  @extend .mb-0;

  thead {
    @extend .text-center;
  }

  tbody {
    th,
    td {
      @extend .text-center;
      @extend .py-0;

      h3,
      h4,
      h5 {
        @extend .mb-0;
      }
    }
  }
}

.progress {
  @extend .mt-3;
  height: 19px;
}
</style>
